/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import {
  Modal,
  Container,
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Divider,
  Typography,
  Box,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { AlertsTable } from "./DataProjectAlertsTable";

interface ProjectAlertsModalProps {
  open: boolean;
  onClose: () => void;
  dataProjectId: number;
  dataProjectName: string;
}

export const ProjectAlertsModal = React.memo(function ProjectAlertsModal({
  open,
  onClose,
  dataProjectId,
  dataProjectName,
}: ProjectAlertsModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="alerts-modal-title"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="md" style={{ padding: "0px" }}>
        <Card>
          <CardHeader
            id="alerts-modal-title"
            title={
              <Box display="flex" alignItems="center">
                <NotificationsActiveIcon
                  color="primary"
                  style={{ marginRight: "10px", fontSize: "2rem" }}
                />
                <Typography variant="h5">Alerts - {dataProjectName}</Typography>
              </Box>
            }
            action={
              <IconButton onClick={onClose} aria-label="Close alerts modal">
                <CloseOutlinedIcon />
              </IconButton>
            }
            style={{ backgroundColor: "#f5f5f5" }}
          />
          <Divider />
          <CardContent style={{ padding: "24px" }}>
            <AlertsTable sourceTypeId={dataProjectId} />
          </CardContent>
        </Card>
      </Container>
    </Modal>
  );
});
